
import React from 'react';
import CustomersTable from './CustomersTable';
import { Skeleton } from '@/components/ui/skeleton';
import { Customer } from '@/lib/supabase/customers/types';
import { Button } from '@/components/ui/button';
import { PlusCircle } from 'lucide-react';
import SelectionSummary from './SelectionSummary';

interface CustomersListViewProps {
  customers: Customer[];
  selectedCustomers: string[];
  loading: boolean;
  toggleSelection: (id: string) => void;
  toggleSelectAll: () => void;
  allSelected: boolean;
  deleting: boolean;
  totalCount: number;
  handleEdit?: (id: string) => void;
  handleDelete?: (id: string) => Promise<boolean>;
  onAddCustomer?: () => void;
  onBulkDelete?: () => void;
}

const CustomersListView = ({
  customers,
  selectedCustomers,
  loading,
  toggleSelection,
  toggleSelectAll,
  allSelected,
  deleting,
  totalCount,
  handleEdit,
  handleDelete,
  onAddCustomer,
  onBulkDelete
}: CustomersListViewProps) => {
  if (loading) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 space-y-4">
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  return (
    <>
      {selectedCustomers.length > 0 && (
        <SelectionSummary 
          selectedCount={selectedCustomers.length} 
          totalCount={totalCount}
          onDelete={onBulkDelete}
          isDeleting={deleting}
        />
      )}
      
      <div className="shadow-sm border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 rounded-lg">
        <div className="p-4 flex justify-between items-center border-b border-gray-200 dark:border-gray-800">
          <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">Clients ({customers.length})</h3>
          
          {selectedCustomers.length === 0 && onAddCustomer && (
            <Button 
              onClick={onAddCustomer}
              className="reference-table-add-button"
              size="sm"
            >
              <PlusCircle className="h-4 w-4 mr-2" />
              Ajouter un client
            </Button>
          )}
        </div>
        
        <CustomersTable 
          customers={customers}
          selectedCustomers={selectedCustomers}
          loading={loading}
          toggleCustomerSelection={toggleSelection}
          toggleSelectAll={toggleSelectAll}
          allSelected={allSelected}
          handleEditCustomer={handleEdit || (() => {})}
          handleDeleteCustomer={handleDelete || (() => Promise.resolve(false))}
          formatDate={(date: string) => new Date(date).toLocaleDateString()}
          formatPhone={(phone?: string) => phone || 'N/A'}
          isDeleting={deleting}
          onRefresh={() => {}}
        />
      </div>
    </>
  );
};

export default CustomersListView;
